import React from 'react';
import { useNavigate } from 'react-router-dom';
import UnifiedNavigation from '../../components/Navigation/UnifiedNavigation';
import Footer from '../../components/Footer/Footer';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import { HandDrawnButton } from '../../components/shared/HandDrawnButton/HandDrawnButton';
import { createSelfbookHandler } from '../../utils/selfbook';
import './AccommodationsAtacama.css';

const AccommodationsAtacama: React.FC = () => {
  const navigate = useNavigate();
  const handleBooking = createSelfbookHandler(navigate, '/atacama/contact');
  return (
    <div className="accommodations-atacama">
      {/* Navigation */}
      <UnifiedNavigation variant="light" destination="atacama" />
      
      {/* 1. Page Header - "Respecting Nature And Ancient Building Techniques" */}
      <section className="accommodations-page-header">
        <div className="accommodations-page-header__content">
          <h1 className="accommodations-page-header__title">
            Respecting Nature And Ancient Buildings Techniques
          </h1>
        </div>
      </section>

      {/* 2. Full Image - Landscape/courtyard */}
      <section className="accommodations-full-image">
        <div className="accommodations-full-image__container">
          <img src="/assets/figma/d36ae0b49c529e7fed4f9034de295d3fe68cf1d4.png" alt="Atacama courtyard landscape" />
        </div>
      </section>

      {/* 3. Subheader Text Section */}
      <section className="accommodations-subheader">
        <div className="accommodations-subheader__container">
          <p className="accommodations-subheader__text">
            At over 2,500 meters above sea level, step foot in this otherworldly place and feel like you're on a different planet. It's called the Atacama Desert, but there is so much more than desert. Enjoy breathtaking landscapes by day and world-class stargazing during the night.
          </p>
        </div>
      </section>

      {/* 4. Two Room Cards Side by Side */}
      <section className="accommodations-room-cards">
        <div className="accommodations-room-cards__container">
          {/* Superior Round Suites */}
          <div className="accommodations-room-card">
            <div className="accommodations-room-card__image">
              <img src="/assets/figma/f8d36502f184423204876f08dda07784a2c30b3c.png" alt="12 Superior Round Suites" />
              <div className="accommodations-room-card__arrows">
                <button className="accommodations-room-card__arrow accommodations-room-card__arrow--left">
                  <img src="/assets/figma/d6f47ba71bd17555ff42192ceee6ab7862780e91.svg" alt="Previous" />
                </button>
                <button className="accommodations-room-card__arrow accommodations-room-card__arrow--right">
                  <img src="/assets/figma/d6f47ba71bd17555ff42192ceee6ab7862780e91.svg" alt="Next" />
                </button>
              </div>
            </div>
            <div className="accommodations-room-card__content">
              <h3 className="accommodations-room-card__title">12 Superior Round Suites</h3>
              <p className="accommodations-room-card__description">
                Nunc urna augue sit vel et enim eget mi tincidunt. Pulvinar est mattis vulputate tempus enim iaculis viverra condimentum.
              </p>
              <div className="accommodations-room-card__actions">
                <button className="accommodations-room-card__link accommodations-room-card__link--primary" onClick={handleBooking}>
                  BOOK YOUR STAY
                </button>
                <button className="accommodations-room-card__link accommodations-room-card__link--secondary">
                  SEE DETAILS
                </button>
              </div>
            </div>
          </div>

          {/* Round Rooms */}
          <div className="accommodations-room-card">
            <div className="accommodations-room-card__image">
              <img src="/assets/figma/d53cfac2cff0fee3442e52c745b5b4b1d7398942.png" alt="2 Round Rooms" />
              <div className="accommodations-room-card__arrows">
                <button className="accommodations-room-card__arrow accommodations-room-card__arrow--left">
                  <img src="/assets/figma/d6f47ba71bd17555ff42192ceee6ab7862780e91.svg" alt="Previous" />
                </button>
                <button className="accommodations-room-card__arrow accommodations-room-card__arrow--right">
                  <img src="/assets/figma/d6f47ba71bd17555ff42192ceee6ab7862780e91.svg" alt="Next" />
                </button>
              </div>
            </div>
            <div className="accommodations-room-card__content">
              <h3 className="accommodations-room-card__title">2 Round Rooms</h3>
              <p className="accommodations-room-card__description">
                Nunc urna augue sit vel et enim eget mi tincidunt. Pulvinar est mattis vulputate tempus enim iaculis viverra condimentum.
              </p>
              <div className="accommodations-room-card__actions">
                <button className="accommodations-room-card__link accommodations-room-card__link--primary" onClick={handleBooking}>
                  BOOK YOUR STAY
                </button>
                <button className="accommodations-room-card__link accommodations-room-card__link--secondary">
                  SEE DETAILS
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 5. Communal Areas Section */}
      <section className="accommodations-communal">
        <div className="accommodations-communal__header">
          <h2 className="accommodations-communal__title">Communal Areas</h2>
        </div>
        <div className="accommodations-communal__content">
          <div className="accommodations-communal__image">
            <img src="/assets/figma/00b8f10b27d61e6097211d954b29878f58048a4d.png" alt="Guests Only Relais & Châteaux Restaurant" />
          </div>
          <div className="accommodations-communal__overlay">
            <div className="accommodations-communal__text">
              <h3 className="accommodations-communal__subtitle">Guests Only Relais & Châteaux Restaurant</h3>
              <p className="accommodations-communal__description">
                Ut maecenas faucibus feugiat velit urna mi turpis nisl. Dis pharetra sem urna metus adipiscing nunc a. Facilisis sollicitudin eu amet id malesuada amet. Enim at sociis natoque nulla massa in lorem elit. Est vel egestas dapibus erat bibendum id sit. Lobortis massa.
              </p>
            </div>
            <div className="accommodations-communal__pagination">
              <div className="accommodations-communal__pagination-dot accommodations-communal__pagination-dot--active"></div>
              <div className="accommodations-communal__pagination-dot">2</div>
              <div className="accommodations-communal__pagination-dot">3</div>
              <div className="accommodations-communal__pagination-dot">4</div>
            </div>
          </div>
        </div>
      </section>

      {/* 6. Full Landscape Image */}
      <section className="accommodations-full-landscape">
        <div className="accommodations-full-landscape__container">
          <img src="/assets/figma/a7ca385cea25f3635392fa96b7c02cf0a6d12cae.png" alt="Desert landscape" />
        </div>
      </section>

      {/* 7. Map Section */}
      <section className="accommodations-destinations-map">
        <div className="accommodations-destinations-map__container">
          <div className="accommodations-destinations-map__content">
            <h3 className="accommodations-destinations-map__title">
              Combine 2 or 3 of our lodges for the perfect South American Adventure
            </h3>
            <p className="accommodations-destinations-map__description">
              When combining our destinations, enjoy complimentary stays at our favourite hotels in connecting cities, plus enjoy local know-how from our experts who will help create your tailor-made experience.
            </p>
            <button className="accommodations-destinations-map__button">
              PLAN YOUR TRIP
            </button>
          </div>
          <div className="accommodations-destinations-map__visual">
            <div className="accommodations-destinations-map__map">
              <img src="/assets/figma/9ca5ea7430f39d4e594a71590d13b2ac5f1837aa.svg" alt="South America map with Awasi locations" />
            </div>
            <div className="accommodations-destinations-map__legend">
              <div className="accommodations-destinations-map__legend-item">
                <div className="accommodations-destinations-map__legend-dot"></div>
                <span>AIRPORTS</span>
              </div>
              <div className="accommodations-destinations-map__legend-item">
                <div className="accommodations-destinations-map__legend-line"></div>
                <span>FLIGHTS & CONNECTIONS</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Instagram Section */}
      <InstagramSection />

      {/* Footer */}
      <Footer variant="atacama" />
    </div>
  );
};

export default AccommodationsAtacama;